export const oktaConfigs= {
    oktaDomain: process.env.REACT_APP_OKTA_DOMAIN,
    oktaClientId: process.env.REACT_APP_OKTA_CLIENT,
    oktaRedirectURL:"/login/callback",
    oktaLogoutURL: "/logout"
}

export const defaultAppTheme={
    "light": {
        "primary": "#192939",
        "primaryText": "#FFFFFF",
        "secondary": "#71A0B2",
        "secondaryText": "#FFFFFF",
        "white": "#FFFFFF",
        "whiteText": "#000000",
        "light": "#F4F4F4",
        "lightText": "000000",
        "background": "#FFFFFF",
        "text": "#00000"
      },
      "dark": {
        "primary": "#192939",
        "primaryText": "#FFFFFF",
        "secondary": "#71A0B2",
        "secondaryText": "#FFFFFF",
        "white": "#000000",
        "whiteText": "#FFFFFF",
        "light": "#000000",
        "lightText": "#FFFFFF",
        "background": "#000000",
        "text": "#FFFFFF"
      }
}

export const appRoutes= {
    login: '/login',
    home: '/',
    explore: '/explore',
    chat: '/chat',
    menu: '/menu',
    errorRoute:'/error',
    insights: '/insights',
    adminPanel: '/admin-panel',
    adminInsights: '/get-all-insights',
    adminKM: '/admin-knowledge-manager',
    adminPM: '/admin-process-manager',
    adminAudit: '/admin-activities',
    adminMasterSOP: '/admin-master-sops',
    adminGrouping: '/admin-domain-groups',
    adminRBAC: '/admin-rbac',
    adminUsers: '/admin-user-management',
    adminBulk: '/admin-bulk-upload',
    tenant: '/tenancy-management',
    logout: '/logout',
    unauthorised: '/unauthorised'
}

export const appConfigs={
    footerText: "© 2024 Copyright Genpact. All Rights Reserved | Powered by Gen AI",
    errorMessageHideDuration: 2000,
    threadCharCount: 50,
    menuCharcount: 50,
    rbacgroupCharCount: 50,
    docNameCount:50,
    masterSOPCharcount: 50,
    questionTypes: {
        default: 'QnA',
        types: [
            {type: 'QnA', title: 'QnA'},
            {type: 'docsearch', title: 'Doc Search'},
        ]
    },
    conversationLength: 10,
    tablePageOptions: [5, 10, 20, 30],
    tableAttributes: {
        column: null,
        order: 'desc',
        search: "",
        page: 1,
        size: 10
    },
    feedbackCharCount: 100,
    negativeFeedbackCategories: ["Partially Correct Answer", "Incorrect Answer", "Information Not Retrieved", "Inappropriate Sources/References"],
    positiveFeedbackCategories: ["Accurate Answer", "Correct Answer", "Appropriate Information Retrieved", "Relevant Sources/References"],
    allowedFileTypes: [".pdf"],
    allowedFileSize: 25,
    masterSOPDocLimit: 4,
    masterSOPDisclaimer: "This action will cost ranging from $7 - $20. Are you sure you want to generate Master SOP for the selected Document(s)?",
    remasterSOPDisclaimer: "This action will cost ranging from $7 - $20. Are you sure you want to regenerate Master SOP?",
    insightsOptions: {
        default: 'min-30',
        options: [
        {time: "min-30", label: "30 Minutes"},
        {time: "h-1", label: "1 Hour"},
        {time: "d-2", label: "2 Days"},
        {time: "m-1", label: "1 Month"},
        {time: "m-3", label: "3 Months"},
        ]
    },
    allowDocDownload: false,
    allowMasterSop:process.env.REACT_APP_MASTER_SOP,
}

export const apiEndpoints={
    backendBaseURL: process.env.REACT_APP_BACKEND_BASE_URL,
    login: '/api/auth/login',
    menu: '/api/users/get-user-menus',
    threads: '/api/qna/conversation_list',
    deleteThread: '/api/qna/conversation',
    editThread: '/api/qna/update_conversation',
    threadDetails: '/api/qna/qna_list',
    adminmenu: '/api/admin/get-all-menus',
    addMenu: '/api/admin/add-menu',
    editMenu: '/api/admin/edit-menu',
    hideUnhide: '/api/admin/toggle-menu',
    deleteMenu: '/api/admin/delete-menu',
    adminAudit: '/api/admin/admin-audit',
    getRbacGroups: '/api/admin/get-rbac-groups',
    createRbacGroup: '/api/admin/create-rbac-group',
    editRbacGroup: '/api/admin/edit-rbac-group',
    deleteRbacGroup: '/api/admin/delete-rbac-group',
    getUsers: '/api/admin/get-users-list',
    toggleUserAdmin: '/api/admin/toggle-admin-access',
    toggleUserGroup: '/api/admin/toggle-group-access',
    documents: '/api/admin/document_list',
    feedback: '/api/qna/user_feedback',
    question: '/api/qna/question',
    docUpload: '/api/admin/upload',
    docEdit: '/api/admin/edit-embedding',
    docDelete: '/api/admin/delete-document',
    masterSOP: '/api/master_sop/generate_master_sop',
    masterSopsList: '/api/master_sop/get_master_sop_List',
    masterSopEdit: '/api/master_sop/edit_master_sop_name',
    deleteMasterSop: '/api/master_sop/delete_master_sop',
    refreshMasterSop: '/api/master_sop/get_master_sop_by_id',
    repeatMasterSop: '/api/master_sop/repeat',
    adminInsights: '/api/admin/get-all-insights',
    multidownload: '/api/admin/bulk_download',
    deactivateUser: '/api/admin/user-deactivate',
    activateUser: '/api/admin/user-activate',
    fetchBulkUploadDocs:'/api/bulk/allfiles',
    saveBulkUpload:'/api/bulk/save',
    submitBulkUpload:'/api/bulk/upload',
    deleteFileRow:'/api/bulk/delete-file',
    generateSasToken:'/api/bulk/sas-token',
    bulkUploadStatus:'/api/bulk/get-request',
    fetchValidationDocs:'/api/bulk/failed-validation',
    submitValidationDocs:'/api/bulk/correction',
    resetBulkUpload:'/api/bulk/delete-request',
    fetchSubmitButtonStatus:'/api/bulk/blob-document-list',
    loadDocument: '/api/qna/get_file_data'
}

//export const docUploadRegex = /^(?!.*[\\/:*?"'<>|~^])[^.].*$/
export const docUploadRegex =/^(?!.*[\\/:*?"'<>^~|])[^\\/:*?"'<>^~|.]+\.pdf$/ 
 
